module.exports = __webpack_public_path__ + "img/df3e759.svg";